import Grid from '@material-ui/core/Grid';
import React from 'react';
import './Checkout.css';
import strings from './components/language/language';

const _stringifyObj = obj => {
  var myobj = { ...obj };
  let addition_string = [];
  Object.keys(myobj).forEach((key, index) => {
    if (typeof myobj[key] === 'string') {
      addition_string.push(' ' + myobj[key].split('%')[0]);
    } else {
      myobj[key].map(element => addition_string.push(element.split('%')[0]));
    }
  });
  return addition_string.join(', ');
};
export default props => {
  const { price } = props;

  return (
    <div>
      <Grid container spacing={0} id='order-container' index={props.index}>
        <Grid item xs={2}>
          <span className='' id='cart-item-count'>
            {props.count}x
          </span>
        </Grid>
        <Grid item xs={7} className='center-align'>
          <span className='bold' id='cart-item-name'>
            {(props.freeItem ? '' : props.size) + ' ' + props.name}{' '}
            <span className='add-ons-checkout'>
              {_stringifyObj(props.add_ons)}{' '}
            </span>
          </span>
        </Grid>
        <Grid item xs={3} className='right-align'>
          <span className='' id='cart-item-price'>
            {props.freeItem
              ? 'free'
              : Number.parseFloat(price).toFixed(2) + strings.currency}
          </span>
        </Grid>
      </Grid>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Cartitem.js